module.exports = __webpack_public_path__ + "static/media/ekedc.a5f9d0d0.svg";